import * as XLSX from "xlsx";

export const excelDownloader = (data, headerCh, headerEn, fileName) => {
  // 建立工作簿
  const workbook = XLSX.utils.book_new();

  // 格式化資料
  const formatData = (sourceData, headers) =>
    sourceData.map((dtEl) => headers.map((hdEl) => dtEl[hdEl]));

  // 插入標題和資料
  const insertSheetWithData = (headers, formattedData) => {
    if (headers) {
      formattedData.unshift(headers);
    }
    const worksheet = XLSX.utils.aoa_to_sheet(formattedData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  };

  if (headerCh && headerEn) {
    const formattedData = formatData(data, headerEn);
    insertSheetWithData(headerCh, formattedData);
  } else if (headerCh && !headerEn) {
    const formattedData = formatData(data, headerCh);
    insertSheetWithData(headerCh, formattedData);
  } else if (!headerCh && headerEn) {
    const formattedData = formatData(data, headerEn);
    insertSheetWithData(headerEn, formattedData);
  } else {
    const worksheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  }

  // 產生 Excel 檔案並下載
  XLSX.writeFile(workbook, fileName || "未命名檔案.xlsx");
};
